module.exports = {
	"base": {
		"welcome": "Bem-vindo ao Mulligans, %{name}!",
		"user": "Informações do usuário",
		"devices": "Dispositivos",
		"refunds": "Reembolsos",
		"resources": "Recursos",
		"transactions": "Encomendas e Devoluções",
		"email": "Email",
		"password": "Senha",
		"save": "Salvar",
		"sign-out": "Sair",
		"cancel": "Cancelar",
		"close": "Fechar",
		"learn-more": "Aprender mais",
		"required": "Obrigatórios",
		"support": "Suporte",
		"bookshelf": "Bookshelf",
		"launch": "Iniciar",
		"download": "Fazer o download",
		"details": "Detalhes",
		"cannot-be-blank": "%{field} não deve estar em branco.",
		"saving": "Salvando...",
		"done": "Concluído",
		"failed": "Falhou",
		"copy": "Copiar"
	},
	"signin": {
		"login-failure": "O e-mail ou a senha está incorreto",
		"welcome-large": "Bem-vindo ao <span class='inner'>Centro de Contas da %{brand}</span>",
		"welcome-small": "<span class='inner'>Centro de Contas</span>",
		"signin-button": "Entrar",
		"forgot-password": "Esqueceu-se de sua senha?",
		"new-to-vst": "É novo na %{brand}?",
		"create-account": "Criar uma conta",
		"signing-in": "Entrando…",
		"signin-failed": "Falha na entrada"
	},
	"transactions": {
		"price": "Preço",
		"excluded": "(Excluindo impostos)",
		"quantity": "Quantidade",
		"confirmation#": "Confirmação nº",
		"payment": "Pagamento",
		"purchased": "Comprado",
		"purchase-details": "Detalhes de compra",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Imposto",
		"loading": "Ei, seu gastador! Estamos carregando sua transação...",
		"no-purchases": "Não há compras.",
		"seller-vat": "IVA do vendedor",
		"total-vat": "%{vat} total pago",
		"portion": "%{subTax} Imposto %{rate}%",
		"vat-disclosure": "O preço inclui %{vat}",
		"purchases": "Compras",
		"refunded-items": "Itens reembolsados",
		"book-title": "Título do livro",
		"refund-details": "Detalhes de reembolso",
		"print-receipt": "Imprimir recibo",
		"request-refund": "Reembolso pedido",
		"expired": "Venceu",
		"expires-in": "Vence em %{date}",
		"details-refund": "Detalhes e reembolso",
		"modal": {
			"cant-refund-title": "Reembolso não disponível",
			"cant-refund": "Seu livro não pode ser reembolsado devido a uma ou mais das seguintes razões.",
			"cant-refund-1": "Uma grande porcentagem de seu livro já foi visualizada.",
			"cant-refund-2": "Faz mais de 14 dias desde a data de compra.",
			"cant-refund-3": "Seu código de recursos online foi revelado.",
			"cant-refund-4": "Seu livro já tinha sido reembolsado.",
			"cant-refund-5": "Todos os códigos já foram resgatados e/ou reembolsados.",
			"cant-refund-6": "Faz mais de 30 dias desde a data de compra.",
			"cant-refund-support": "Caso você ainda tenha dúvidas em relação à política de reembolso da %{brand}, entre em contato com o <a href='%{support_url}' target='_blank'>suporte</a>."
		},
		"license": {
			"perpetual": "O acesso online não vence",
			"days": "Acesso de %{days} dias"
		}
	},
	"devices": {
		"description": "%{brand} permite que você tenha <span>%{desktop}</span> computadores e <span>%{mobile}</span> dispositivos móveis ativados a qualquer momento.",
		"loading": "Oba, estamos captando seus dispositivos :)",
		"no-active": "Você não tem dispositivos ativos.",
		"deactivate": "Desativar"
	},
	"user": {
		"personal-information": "Informações pessoais",
		"security-information": "Informações de segurança",
		"notifications": "Notificações",
		"first-name": "Nome",
		"last-name": "Sobrenome",
		"change-password-title": "Altere a Senha",
		"current-password": "Senha atual",
		"new-password": "Nova senha",
		"security-password": "Senha",
		"confirm-new-password": "Confirme a nova senha",
		"security-question": "Pergunta de segurança",
		"security-info-change": "Alterar",
		"question": "Pergunta",
		"answer": "Resposta",
		"notifications-text": "Favor enviar-me por e-mail atualizações ocasionais sobre minha atividade de conta, atualizações de produtos e ofertas especiais.",
		"loading": "O Spot foi buscar suas informações de usuário. Aguarde... 🐶",
		"change-password-text": "A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, e um caractere especial.",
		"email-locked": "E-mail bloqueado",
		"email-locked-description": "Você não tem acesso para alterar o seu e-mail.",
		"email-locked-more": "Entre em contato com o seu administrador.",
		"security-question6": "Qual é seu esporte favorito?",
		"security-question7": "Qual é o seu sabor favorito de sorvete?",
		"security-question8": "Qual é o nome do seu animal de estimação favorito?",
		"security-question9": "Quando você era jovem, o que queria ser ao crescer?",
		"security-question10": "Qual foi o último nome do seu professor favorito?",
		"new-password-failure": "A senha não atende às exigências",
		"confirm-password-failure": "A senha deve ser igual",
		"new-password-tooltip": "Deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, e um caractere especial.",
		"enter-valid-email": "Insira um e-mail válido.",
		"password-cannot-be-same": "A senha não pode ser igual à anterior",
		"incorrect-password": "Senha incorreta",
		"complete-account": "Parece que você precisa <a href='%{href}'>completar a sua conta</a>.",
		"completing-allows": "Ao completar a sua conta você poderá ler livros offline em seus aplicativos móveis e compartilhar notas e realces com amigos.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Auxiliares",
		"access-codes": "Códigos de acesso",
		"print-on-demand": "Imprimir a pedido",
		"check-pod": "Verifique as opções de impressão do editor para os seus livros.",
		"check-now": "Marque agora",
		"loading": "Aguente firme! Estamos atualizando seus recursos!",
		"in": "em",
		"access-code-intro": "Um código de acesso é uma senha que você usa para acessar conteúdo de curso online. Quando você revelar um código de um item, não será possível desfazê-lo. Para obter mais instruções sobre como usar seus códigos de acesso, visite <a href='%{support_url}' target='_blank'>Suporte</a>.",
		"expires": "Vence em",
		"expiration-message": "Contém instruções para usar seu código de acesso.",
		"copy-fail": "Não é possível copiar. Selecione o código e copie-o manualmente.",
		"launch-site": "Site para iniciar",
		"launch-book": "Iniciar livro",
		"reveal-code": "Revelar Código",
		"no-resources": "Você não tem nenhum recurso.",
		"no-access-codes": "Você não tem nenhum código de acesso.",
		"no-ancillaries": "Não há auxiliares para este título",
		"name": "Nome",
		"type": "Tipo",
		"size": "Tamanho",
		"download-all": "Fazer o download de tudo",
		"back": "Voltar para recursos"
	},
	"refunds": {
		"states": {
			"refunded": "Reembolsado",
			"unavailable": "Reembolso indisponível"
		},
		"reasons": {
			"dropped": "Desisti do curso",
			"wrong": "Este não era o livro certo para meu curso",
			"print": "Decidi comprar uma versão impressa",
			"missing": "Este livro não contém tudo o que preciso para meu curso (p. ex., um CD, acesso à web, vídeos)",
			"other": "Outro"
		},
		"bulk": {
			"policy": "Ao clicar no botão &quot;Reembolso total&quot; abaixo, eu concordo com a política de reembolso da <a href='%{policy_url}' target='_blank'>%{brand}</a>.",
			"complete": "Reembolso total",
			"view-details": "Exibir detalhes de reembolso",
			"success": "O reembolso foi solicitado. Aguarde 48 horas para o processamento.",
			"failure": "Opa! Algo deu errado! Infelizmente o seu reembolso não foi aprovado.",
			"retry": "Tente novamente",
			"support": "Contatar suporte",
			"available-codes": "Códigos disponíveis",
			"codes-selected": "Códigos selecionados",
			"download": "Fazer o download dos códigos",
			"partially-refunded": "Parcialmente reembolsado",
			"pick-one": "É necessário selecionar pelo menos um código para solicitar um reembolso"
		},
		"refund": "Reembolso",
		"all": "Reembolsar tudo?",
		"missing-reason": "É necessário selecionar uma razão para continuar",
		"missing-elaboration": "Detalhes",
		"policy": "Ao clicar no botão “Solicitação de reembolso total” abaixo, compreendo que, se eu comprar este eTextbook da %{brand} novamente, não terei o direito de solicitar mais nenhum reembolso em relação ao mesmo eTextbook. Veja a política de devoluções completa.",
		"refunded": "Reembolsado",
		"sorry": "Lamentamos por você não ter ficado satisfeito com sua compra.",
		"error": "Algo deu errado",
		"error-explain": "Não foi possível processar seu reembolso. Tente novamente.",
		"why": "Diga-nos por quê.",
		"no-refunds": "Você não tem itens reembolsados.",
		"select-codes": "Selecione código(s) para reembolso:",
		"number": "Quantos?",
		"back": "Voltar para reembolsos"
	},
	"purchases": {
		"back": "Voltar para compras"
	},
	"global-bar": {
		"account": "Configurações da conta"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/pt-BR.json
 ** module id = 1019
 ** module chunks = 0
 **/